// extracted by mini-css-extract-plugin
export default {"root":"ScheduleEvents_root__6YIZ+","btn":"ScheduleEvents_btn__pPNom","rootDeleteble":"ScheduleEvents_rootDeleteble__7P+PX","rootPrev":"ScheduleEvents_rootPrev__lBUmx"};